/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import dayjs, { ManipulateType } from 'dayjs';
import { Flex } from '~/shared/components';
import { ReactComponent as Calendar } from '~/shared/assets/Calendar.svg';
import { dateValues, dateSubstractNumbers, dateSubstractMeasures } from '../constants';
import { DisplayDateProps } from '../types';

const Wrapper = styled(Flex)`
  align-items: center;
  margin-left: 4px;
  cursor: pointer;
`;

const DateValue = styled('div')`
  margin: 0 5px;
  font-size: 16px;
  font-weight: 400;
  color: var(--text-color);
  left: 50%;
`;

const StyledCalendar = styled(Calendar)`
  color: var(--icon-color);
  fill: var(--icon-color);
  margin-top: -5px;
`;

const DisplayDate = ({ value, onClick, measure }: DisplayDateProps) => {
  return (
    <Wrapper onClick={onClick}>
      <DateValue>{dayjs(value).format('MMM DD YYYY')}</DateValue>
      <StyledCalendar />
    </Wrapper>
  );
};

export default DisplayDate;
